import bem from 'utils/bem';

export const block = bem('video-template-add-media');
